module.exports = __webpack_public_path__ + "static/img/stay-option-icon-elevator.acd2313e.svg";